export enum CommandSource {
  MONITOR = 'MONITOR',
  MINI_MONITOR = 'MINI_MONITOR',
  REMOTE_JOYSTICK = 'REMOTE_JOYSTICK',
}

export interface VehicleListRequest {
  cockpitNumber: string;
  pageSize: number;
  pageNum: number;
}

export interface VehicleListResponse {
  pages: number;
  pageSize: number;
  total: number;
  pageNum: number;
  list: VehicleData[];
}
export enum TakeOverStatus {
  TAKEOVER = 'TAKEOVER',
  TEMPORARY = 'TEMPORARY',
}

export enum TakeOverStatusText {
  TAKEOVER = '急停接管',
  TEMPORARY = '临停接管',
}
export interface VehicleData {
  vehicleName: string;
  stationName: string;
  vehicleState: string;
  scheduleState: string;
  speed: number;
  scene: string[];
  systemState: string;
  takeOverUserName?: string;
  takeOverSource?: string;
  takeOverStatus?: string;
  alarmEventList: {
    alarmEvent?: string;
    reportTime: string;
  }[];
  globalMileage?: number;
  arrivedMileage: number;
}

export interface TemporaryStopRequest {
  vehicleName: string;
  timeStamp: number;
  commandSource?:
    | CommandSource.MINI_MONITOR
    | CommandSource.MONITOR
    | CommandSource.REMOTE_JOYSTICK;
}
